import { RadioGroup as ChakraRadioGroup } from '@chakra-ui/react'
import * as React from 'react'

export type RadioGroupProps = ChakraRadioGroup.RootProps

/** Chakra radio group with `colorPalette="brand"` as the default palette. */
export const RadioGroup = React.forwardRef<HTMLDivElement, RadioGroupProps>(
  function RadioGroup(props, ref) {
    return <ChakraRadioGroup.Root ref={ref} colorPalette="brand" {...props} />
  },
)

export interface RadioProps extends ChakraRadioGroup.ItemProps {
  /** Props forwarded to the hidden native `<input type="radio">`. */
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
  /** Ref for the item root element. The forwarded ref targets the input. */
  rootRef?: React.Ref<HTMLDivElement>
}

/** A single option inside a `RadioGroup`. */
export const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  function Radio(props, ref) {
    const { children, inputProps, rootRef, ...rest } = props
    return (
      <ChakraRadioGroup.Item ref={rootRef} {...rest}>
        <ChakraRadioGroup.ItemHiddenInput ref={ref} {...inputProps} />
        <ChakraRadioGroup.ItemIndicator />
        {children != null && (
          <ChakraRadioGroup.ItemText>{children}</ChakraRadioGroup.ItemText>
        )}
      </ChakraRadioGroup.Item>
    )
  },
)
